import ROUTES from "@config/routes";

export enum TypesPermissions {
  // Módulos de usuário
  HOME = "portal_cliente:home:*",
  ORDER = "portal_cliente:orders:*",
  TITLES = "portal_cliente:titles:*",
  INVOICES = "portal_cliente:invoices:*",
  PRODUCT_PRICES = "portal_cliente:product_prices:*",
  APPOINTMENT = "portal_cliente:appointment:*",
  SAC = "portal_cliente:sac:*",
  DRIVER = "portal_cliente:driver:*", // módulo de acesso a Meus Motoristas; perfil motorista usa ROLE_CIF_DRIVER
  CARRIER = "portal_cliente:carrier:*", // módulo de acesso; perfil transportadora usa ROLE_CARRIER
  CAMPAIGN_METRICS = "portal_cliente:campaign_metrics:*",
  PERFORMANCE_MANAGEMENT = "portal_cliente:performance_management:*",
  DISCOUNT = "portal_cliente:discount:*",
  GOALS_AND_COMMISSIONS = "portal_cliente:goals_and_commissions:*",
  NOZZLES = "portal_cliente:nozzles:*",
  ANNOUNCEMENTS = "portal_cliente:announcements:*",
  CHANGE_PASSWORD = "portal_cliente:change_password:*",
  NOTIFICATIONS = "portal_cliente:notifications:*",

  // Módulos com mapeamento aproximado — TODO: aguardar permissão definitiva do backend
  EMPLOYEE = "portal_cliente:home:*", // TODO: mapeamento aproximado
  COLETA = "portal_cliente:home:*", // TODO: mapeamento aproximado
  SIMULATION = "portal_cliente:appointment:*", // TODO: mapeamento aproximado

  // Módulos admin
  ADMIN_HOME = "portal_cliente:admin:home:*",
  ADMIN_USERS = "portal_cliente:admin:users:*",
  ADMIN_INVOICES = "portal_cliente:admin:invoices:*",
  ADMIN_PRODUCT_BLOCK = "portal_cliente:admin:product_block:*",
  ADMIN_ANNOUNCEMENTS = "portal_cliente:admin:announcements:*",
  ADMIN_SAC = "portal_cliente:admin:sac:*",
  ADMIN_NOZZLES = "portal_cliente:admin:nozzles:*",
  ADMIN_NOTIFICATIONS = "portal_cliente:admin:notifications:*",
}

// NOTE: Constantes com valor duplicado (EMPLOYEE, COLETA → HOME; SIMULATION → APPOINTMENT)
// são intencionais enquanto aguardam permissão definitiva do backend.
// O permissionRouteMap usa apenas as chaves primárias para evitar sobrescrita de rotas.
export const permissionRouteMap: Record<string, string> = {
  [TypesPermissions.HOME]: ROUTES.USER_ROUTES.HOME,
  [TypesPermissions.APPOINTMENT]: ROUTES.USER_ROUTES.ROADLOAD,
  [TypesPermissions.DRIVER]: ROUTES.USER_ROUTES.MY_DRIVERS,
  [TypesPermissions.PRODUCT_PRICES]: ROUTES.USER_ROUTES.APPOINTMENT_PRICE,

  /* Note: As rotas abaixo fazem parte da home e nao podem sofrer redirecionamento automatico.

  [TypesPermissions.ORDER]: ROUTES.USER_ROUTES.NEW_ORDER,
  [TypesPermissions.TITLES]: ROUTES.USER_ROUTES.APPOINTMENT_TITLE,
  [TypesPermissions.INVOICES]: ROUTES.USER_ROUTES.APPOINTMENT_INVOICES,

  */
  [TypesPermissions.CAMPAIGN_METRICS]: ROUTES.USER_ROUTES.DASH_POSH,
  [TypesPermissions.PERFORMANCE_MANAGEMENT]:
    ROUTES.USER_ROUTES.PERFORMANCE_MANAGEMENT,
  [TypesPermissions.DISCOUNT]: ROUTES.USER_ROUTES.DISCOUNT,
  [TypesPermissions.GOALS_AND_COMMISSIONS]:
    ROUTES.USER_ROUTES.GOALS_AND_COMMISSIONS,
  [TypesPermissions.NOZZLES]: ROUTES.USER_ROUTES.NOZZLE,
  // Rotas admin
  [TypesPermissions.ADMIN_HOME]: ROUTES.ADMIN_ROUTES.HOME,
  [TypesPermissions.ADMIN_USERS]: ROUTES.ADMIN_ROUTES.LIST_USERS,
  [TypesPermissions.ADMIN_INVOICES]: ROUTES.ADMIN_ROUTES.LIST_INVOICES_IMAGES,
  [TypesPermissions.ADMIN_PRODUCT_BLOCK]: ROUTES.ADMIN_ROUTES.PRODUCT_BLOCK,
  [TypesPermissions.ADMIN_ANNOUNCEMENTS]: ROUTES.ADMIN_ROUTES.ALL_COMMUNICATION,
  [TypesPermissions.ADMIN_SAC]: ROUTES.ADMIN_ROUTES.RECLAMATION_ANALYSIS,
  [TypesPermissions.ADMIN_NOZZLES]: ROUTES.ADMIN_ROUTES.NOZZLE,
  [TypesPermissions.ADMIN_NOTIFICATIONS]:
    ROUTES.ADMIN_ROUTES.NOTIFICATIONS.ROOT,
};

// Roles em ROLES[] — não entram no permissionRouteMap
export const ROLE_PORTAL_CLIENTE = "portal_cliente";
export const ROLE_CIF_DRIVER = "cif_driver";
export const ROLE_CARRIER = "carrier";
export const ROLE_FOB_DRIVER = "fob_driver";

export enum WhatPermission {
  WRITE = "*:WRITE",
}
